import {
  DestroyRef,
  Directive,
  ElementRef,
  NgZone,
  afterNextRender,
  effect,
  inject,
  input,
  output,
} from '@angular/core';

@Directive({
  selector: '[appInfiniteScrollTrigger]',
  standalone: true,
})
export class InfiniteScrollTriggerDirective {
  public readonly disabled = input(false);
  public readonly throttleMs = input(500);

  public readonly reached = output<void>();

  private readonly elementRef = inject(ElementRef<HTMLElement>);
  private readonly zone = inject(NgZone);
  private readonly destroyRef = inject(DestroyRef);

  private observer?: IntersectionObserver;
  private lastTriggeredAt = 0;

  constructor() {
    afterNextRender(() => {
      this.setupObserver();
    });

    effect(() => {
      if (this.disabled()) {
        this.lastTriggeredAt = Date.now();
      }
    });

    this.destroyRef.onDestroy(() => {
      this.observer?.disconnect();
    });
  }

  private setupObserver(): void {
    this.zone.runOutsideAngular(() => {
      this.observer = new IntersectionObserver((entries) => {
        const entry = entries[0];
        if (!entry || !entry.isIntersecting || this.disabled()) {
          return;
        }

        const now = Date.now();
        if (now - this.lastTriggeredAt < this.throttleMs()) {
          return;
        }

        this.lastTriggeredAt = now;
        this.zone.run(() => {
          this.reached.emit();
        });
      });

      this.observer.observe(this.elementRef.nativeElement);
    });
  }
}
